import { Route, Routes } from "react-router-dom";
// import { MenuButton, MenuItem } from "@carbon/react";

import {
  PageBanner,
  QuickTable,
  QuickTableFilterTabs,
} from "../../../components";
import { CreateBatchBankTransferForm } from "./CreateBatchBankTransferForm";
import { transferBatchesDisplayFormatter } from "./transferBatchesDisplayFormatter";
import {
  BATCH_TRANSFERS_LIST_TABLE_NAME,
  ITransferViewProps,
} from "./Transfers";
import { TransferBatchDetailsModal } from "./TransferBatchDetailsModal";

import linkColoredIcon from "../../../assets/icons/link-colored.svg";
import { TransferReceiptModal } from "./TransferReceiptModal";
import { TransfersViewModeSelector } from "../TransfersViewModeSelector";
import { batchTransferStatus, transferListViewModes } from "../../../enums";
import { SingleTransferNoBatchList } from "../SingleTransferNoBatchList";

export const View = (props: ITransferViewProps) => {
  return (
    <>
      <PageBanner
        iconSource={linkColoredIcon}
        pageTitle={"Transfers & Bill Payments"}
        pageSubtitle={"Load money into your SwitchApp for transfers"}
        pageDescription={
          "You can also pay utilities and salaries directly from your SwitchApp wallet."
        }
        hideLink
        // linkTitle={"Create payment links for your products"}
        // linkSubtitle={"Create a custom payment page and share a link to it.."}
        // linkButtonText={"Create payment link"}
        // linkButtonUrl={"create"}
        // linkButtonAction={props.openCreatePaymentLinkModal}
      />

      <TransfersViewModeSelector
        defaultMode={transferListViewModes.batchView}
        singlesComponent={<SingleTransferNoBatchList />}
        batchComponent={
          <QuickTable
            id={BATCH_TRANSFERS_LIST_TABLE_NAME}
            prefixFiltersWithId
            data={props.data}
            headers={props.headers}
            isLoading={props.isLoading}
            isError={props.isError}
            itemCount={props.totalCount}
            renderDetail={(item) => item.description}
            toolbarTabs={
              <QuickTableFilterTabs
                queryStringTabNavLinks={props.queryStringTabs}
                filterPrefix={BATCH_TRANSFERS_LIST_TABLE_NAME}
              />
            }
            displayFormatter={transferBatchesDisplayFormatter}
            onExport={props.onExport}
            // openCreateNewModalButton={
            //   <MenuButton label="New Transfer">
            //     <MenuItem
            //       label="Single Transfer"
            //       onClick={props.openCreateNewModal}
            //     />
            //     <MenuItem
            //       label="Batch Upload (Excel)"
            //       onClick={props.openCreateNewBatchUploadExcel}
            //     />
            //   </MenuButton>
            // }
            openCreateNewModal={props.openCreateNewModal}
            createNewButtonText="New Transfer"
            openDetailsModal={props.openDetailsModal}
            detailsModalKeySelector={(transfer) => transfer.batch_reference}
            rowClassNameSelector={(transfer) => {
              // console.warn("batch transfer to render", transfer);

              return transfer?.is_approval_required &&
                !transfer?.is_approved &&
                transfer?.status === batchTransferStatus.awaitingApproval
                ? "batch-transfer-pending-approval"
                : "";
            }}
            // disableClickOnColumns={["batch_reference_display"]}
            disableClickOnTargetClassNames={["copy-btn"]}
          />
        }
      />

      <Routes>
        <Route
          path="create/*"
          element={
            <CreateBatchBankTransferForm
              refreshTable={props.refreshTable}
              goBackOnClose={false}
            />
          }
        />

        <Route
          path="batch/:batch_ref/transfers/*"
          element={
            <>
              <TransferBatchDetailsModal />
            </>
          }
        />
      </Routes>
    </>
  );
};
